import React from "react";
import styled from "styled-components";
import Footer from "./Footer";
import GlobalStyle from "../styles/GlobalStyle";

const Main = styled.main`
  min-height: 100vh;
`;

const Layout = ({ children }) => {
  return (
    <>
      <GlobalStyle />
      <Main>{children}</Main>
      <Footer />
    </>
  );
};

export default Layout;
